import MUITableRow from "@mui/material/TableRow";
import styled from "@emotion/styled";

export const TableRow = styled(MUITableRow)``;
